export function HubIcon({ size = 35, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      color="white"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      className={className}
      {...props}
    >
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" />
      <circle cx="12" cy="5.5" r="0.8" />
      <circle cx="18.5" cy="12" r="0.8" />
      <circle cx="12" cy="18.5" r="0.8" />
      <circle cx="5.5" cy="12" r="0.8" />
    </svg>
  );
}